import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'
import moment from 'moment-timezone'
import Link from '../utils/link'
import ProjectHeroBanner from '../components/cards/project-hero-banner'
import Seo from '../components/seo'
import Map from '../components/map'
import SignOff from '../components/sign-off'
import BedBathCar from '../components/bed-bath-car'
import Gallery from '../components/gallery'
import EnquiryForm from '../components/enquiry-form'
import { Close, FloorPlan, RightArrow, Download } from '../components/icons'
import FsLightbox from 'fslightbox-react'
import SearchOverlay from '../components/search-overlay'
import PropertyAgents from '../components/property-agents'

function filterIt(arr, searchKey) {
  return arr.filter(function(obj) {
    return Object.keys(obj).some(function(key) {
      return obj[key].includes(searchKey)
    })
  })
}

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

class PropertyTemplate extends Component {

  state = {
    showForm: false,
    imageLightbox: false,
    videoLightbox: false,
    floorplanLightbox: false,
    showMore: false
  }

  _toggleForm = (key) => {
    this.setState({ showForm: key })
  }

  openVideo = () => {
    this.setState({ videoLightbox: !this.state.videoLightbox })
  }

  openGallery = () => {
    this.setState({ imageLightbox: !this.state.imageLightbox })
  }

  renderText = (el, i) => {
    if (el.length === 0) return
    if (el.indexOf('•') !== -1) return <li key={i}>{ el.replace(/•/gi, '') }</li>
    return <p key={i} dangerouslySetInnerHTML={{ __html: el }} />
  }

  render() {

    let list = []

    let canSearch = false

    let { showForm, imageLightbox, videoLightbox, floorplanLightbox, showMore } = this.state

    let address = [];

    let { wp } = this.props.data

    let project = this.props.data.wpProject

    address = project.title.split(",")

    let video = project.acf.video
    if (video) video = `https://www.youtube.com/watch?v=${video.split('.be/')[1]}`

    let floorplan = project.acf.floorplan?.localFile?.childImageSharp?.original?.src

    // let today = new Date()
    // today.setDate(today.getDate() - 1)

    // let hasInspections = false
    // if (inspections?.length > 0 ) {
    //   inspections.map((el, i) => {
    //     if (moment(el.start, "YYYY-MM-DD").tz("Australia/Melbourne").isAfter(today)) hasInspections = true
    //   })
    // }

    // let hasAuction = false
    // if (property.propertyMeta.auctionDetails?.dateTime ) {
    //   if (moment(property.propertyMeta.auctionDetails?.dateTime, "YYYY-MM-DD").tz("Australia/Melbourne").isAfter(today)) hasAuction = true
    // }

    let postType = 'project'
    let propertyType = 'project'
    let status = project.acf.status

    let label = status

    let color = '#FFFFFF'

    let signOff = <SignOff {...wp.siteSettings.acf.propertiesBuyCta} />

    let addressPartOne = address[0]
    let addressLowerCase = project.title.toLowerCase()
    let addressUrl = encodeURIComponent(addressLowerCase)

    return (
      <>
        <Seo title={he.decode(project.seo.title)} bodyClass={`${project.slug} dark-theme projects-theme`} description={project.seo.metaDesc} />
        <SearchOverlay canSearch={canSearch} type="buy" postType={postType} propertyType={propertyType} />
        <article className='single-property'>
          <div className='single-property__inner'>
            <div className='single-property__content'>
              <div className='single-property__hero-banner'>
                <ProjectHeroBanner single={true} label={label} postType={postType} propertyType={ propertyType } {...project} color={color} />
              </div>
            </div>
          </div>

          { project.acf.images.length > 0 &&
            <div className='single-property__gallery'>
              <Gallery images={ project.acf.images } project={true} video={video} openVideo={this.openVideo} openGallery={this.openGallery} />
            </div>
          }

          <div className='single-property__inner'>

            <div className='single-property__details'>

              <div className={`single-property__enquiry ${showForm ? 'showing' : ''} `}>

                <p className="form-close" onClick={() => this._toggleForm(0)} ><Close color={color} /><span>Close</span></p>

                <EnquiryForm property={project.title} agent={project.acf.agents?.length > 0 && project.acf.agents[0].info?.email} />

              </div>

              <div className='single-property__menu'>

                <div className='single-property__menu-upper'>

                  { address.length >= 1 &&
                    <div className='property__address'>
                      <ul className='address'>
                        <li>{ address[0] }</li>
                        <li>{ address[1] }</li>
                      </ul>
                    </div>
                  }

                  { propertyType === 'project' &&
                    <BedBathCar color={color} carports={project.acf.stats.car} beds={ project.acf.stats.bed } baths={ project.acf.stats.bath } />
                  }

                  { project.acf.displayPrice &&
                    <p className='price'>{ project.acf.displayPrice }</p>
                  }

                </div>

              </div>

              <div className='single-property__copy'>

                {  project.acf.mainHeadline && <h3 dangerouslySetInnerHTML={{ __html: project.acf.mainHeadline }} /> }

                <div className={`single-property__text ${showMore && 'active'}`} dangerouslySetInnerHTML={{ __html: project.acf.description }} />

                <button
                  type='button'
                  className='btn'
                  onClick={() => this.setState({ showMore: !this.state.showMore })}
                >
                  {showMore ? 'Show Less' : 'Show More'}
                </button>

              </div>

              <div className='single-property__agents'>

                <ul className='agents-menu'>
                  { project.acf.actionList?.length > 0 && project.acf.actionList.map((el, i) => (
                    <li key={i}>
                      <a href={el.link.url} target="_blank" rel="noopener noreferrer">
                        {el.link.title}
                      </a>
                    </li>
                  ))}
                  <li><button onClick={() => this._toggleForm(1)}>Enquire <RightArrow color={color} /></button></li>
                  <li><button type='button' onClick={() => this.setState({ imageLightbox: !imageLightbox })}>Gallery</button></li>
                  { floorplan && <li><button type='button' onClick={() => this.setState({ floorplanLightbox: !floorplanLightbox })}>Floorplan <FloorPlan color={color} /></button></li> }
                  <li><Link to='/appraisals/'>Get an Appraisal</Link></li>
                </ul>

                { project.acf.agents.length > 0 &&
                  <div className='single-property__agents-accounts'>
                    <PropertyAgents project={true} agents={project.acf.agents} />
                  </div>
                }

              </div>

            </div>

            { project.acf.agents.length > 0 &&
              <div className='single-property__mobile-agents-accounts'>
                <PropertyAgents project={true} agents={project.acf.agents} />
              </div>
            }

            <div className='single-property__location'>
              <BlockUpdate>
                <Map lat={project.acf.map.latitude} lng={project.acf.map.longitude} />
              </BlockUpdate>
            </div>
            { signOff && signOff }
          </div>
        </article>


        { project.acf.images?.length > 0 &&
          <FsLightbox
            toggler={imageLightbox}
            sources={project.acf.images.map((el, idx) => {
              return (
                <img
                  key={idx}
                  src={el.localFile.childImageSharp.original.src}
                  alt='Gartland'
                />
              )
            })}
          />
        }

        { video &&
          <FsLightbox
            toggler={videoLightbox}
            sources={ [
              video
            ]}
          />
        }

        { floorplan &&
          <FsLightbox
            toggler={floorplanLightbox}
            sources={ [
              <img
                className='floorplan-image'
                src={floorplan}
                alt='Gartland'
              />
            ]}
          />
        }

      </>
    )
  }
}

export const projectQuery = graphql`
  query ($id: String!) {
    wpProject(id: {eq: $id}) {
      title
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      acf {
        status
        images {
          localFile {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        floorplan {
          localFile {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        video
        map {
          latitude
          longitude
        }
        stats {
          bed
          bath
          car
          landSize {
            value
            unit
          }
          buildingSize {
            value
            unit
          }
          properties
        }
        displayPrice
        searchPrice
        mainHeadline
        description
        agents {
          ... on WpTeam {
            id
            title
            slug
            phoneNumbers {
              comment
              number
              typeCode
              type
            }
            info {
              id
              email
              thumbnail
              image
              firstName
              lastName
              staffTypeId
            }
            acf {
              phone
              email
              profileImage {
                localFile {
                  childImageSharp {
                    original {
                      src 
                    }
                  }
                }
              }
            }
          }
        }
        actionList {
          link {
            title
            url
          }
        }
      }
    }
    wp {
      siteSettings {
        acf {
          propertiesBuyCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`

export default PropertyTemplate
